module.exports = __webpack_public_path__ + "static/resources-bg@2x-b5b18405bdee40db4724610da920da0e.jpg";